var map = {
	"./image/diagrammer/balls/billiards/ball-cue.svg": 46446,
	"./image/diagrammer/balls/billiards/ball-ghost.svg": 15942,
	"./image/diagrammer/balls/billiards/ball-red.svg": 48226,
	"./image/diagrammer/balls/billiards/ball-yellow.svg": 77609,
	"./image/diagrammer/balls/chalkysticks/ball-1.svg": 23499,
	"./image/diagrammer/balls/chalkysticks/ball-10.svg": 54769,
	"./image/diagrammer/balls/chalkysticks/ball-11.svg": 35168,
	"./image/diagrammer/balls/chalkysticks/ball-12.svg": 39571,
	"./image/diagrammer/balls/chalkysticks/ball-13.svg": 34402,
	"./image/diagrammer/balls/chalkysticks/ball-14.svg": 4621,
	"./image/diagrammer/balls/chalkysticks/ball-15.svg": 22028,
	"./image/diagrammer/balls/chalkysticks/ball-2.svg": 65432,
	"./image/diagrammer/balls/chalkysticks/ball-3.svg": 90793,
	"./image/diagrammer/balls/chalkysticks/ball-4.svg": 21382,
	"./image/diagrammer/balls/chalkysticks/ball-5.svg": 10359,
	"./image/diagrammer/balls/chalkysticks/ball-6.svg": 55908,
	"./image/diagrammer/balls/chalkysticks/ball-7.svg": 53157,
	"./image/diagrammer/balls/chalkysticks/ball-8.svg": 31810,
	"./image/diagrammer/balls/chalkysticks/ball-9.svg": 19187,
	"./image/diagrammer/balls/chalkysticks/ball-cue.svg": 51543,
	"./image/diagrammer/balls/chalkysticks/ball-ghost.svg": 88523,
	"./image/diagrammer/balls/cyclop/ball-1.svg": 89572,
	"./image/diagrammer/balls/cyclop/ball-10.svg": 94652,
	"./image/diagrammer/balls/cyclop/ball-11.svg": 23197,
	"./image/diagrammer/balls/cyclop/ball-12.svg": 76926,
	"./image/diagrammer/balls/cyclop/ball-13.svg": 96975,
	"./image/diagrammer/balls/cyclop/ball-14.svg": 3184,
	"./image/diagrammer/balls/cyclop/ball-15.svg": 94305,
	"./image/diagrammer/balls/cyclop/ball-2.svg": 94167,
	"./image/diagrammer/balls/cyclop/ball-3.svg": 31366,
	"./image/diagrammer/balls/cyclop/ball-4.svg": 58249,
	"./image/diagrammer/balls/cyclop/ball-5.svg": 99096,
	"./image/diagrammer/balls/cyclop/ball-6.svg": 37931,
	"./image/diagrammer/balls/cyclop/ball-7.svg": 32666,
	"./image/diagrammer/balls/cyclop/ball-8.svg": 58413,
	"./image/diagrammer/balls/cyclop/ball-9.svg": 22956,
	"./image/diagrammer/balls/cyclop/ball-cue.svg": 95720,
	"./image/diagrammer/balls/cyclop/ball-ghost.svg": 54488,
	"./image/diagrammer/balls/generic/ball-cue.svg": 93177,
	"./image/diagrammer/balls/generic/ball-ghost.svg": 9061,
	"./image/diagrammer/balls/generic/ball-solid-generic-8.svg": 71806,
	"./image/diagrammer/balls/generic/ball-solid-generic-ghost.svg": 10223,
	"./image/diagrammer/balls/generic/ball-solid-generic-red.svg": 6303,
	"./image/diagrammer/balls/generic/ball-solid-generic-yellow.svg": 53010,
	"./image/diagrammer/balls/generic/ball-solid-generic.svg": 4261,
	"./image/diagrammer/balls/generic/ball-stripe-generic.svg": 19843,
	"./image/diagrammer/balls/snooker/ball-black.svg": 49959,
	"./image/diagrammer/balls/snooker/ball-blue.svg": 19918,
	"./image/diagrammer/balls/snooker/ball-brown.svg": 57114,
	"./image/diagrammer/balls/snooker/ball-cue.svg": 32047,
	"./image/diagrammer/balls/snooker/ball-ghost.svg": 74915,
	"./image/diagrammer/balls/snooker/ball-green.svg": 22975,
	"./image/diagrammer/balls/snooker/ball-pink.svg": 86866,
	"./image/diagrammer/balls/snooker/ball-red.svg": 13931,
	"./image/diagrammer/balls/snooker/ball-yellow.svg": 82894,
	"./image/diagrammer/cues/cue.svg": 1183,
	"./image/diagrammer/cues/generic.svg": 85129,
	"./image/diagrammer/cues/sneakypete.svg": 43095,
	"./image/diagrammer/line-dashed.svg": 18165,
	"./image/diagrammer/line-solid.svg": 10555,
	"./image/diagrammer/masse-ball.svg": 86082,
	"./image/diagrammer/masse-grid.svg": 72773,
	"./image/diagrammer/tables/table-horizontal-3.svg": 62026,
	"./image/diagrammer/tables/table-horizontal-7.svg": 54486,
	"./image/diagrammer/tables/table-horizontal-8.svg": 11905,
	"./image/diagrammer/tables/table-horizontal-9.svg": 20784,
	"./image/diagrammer/tables/table-horizontal-billiard.svg": 40736,
	"./image/diagrammer/tables/table-snooker.svg": 90695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96587;